import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Kursteilnehmer } from '../_models/teilnehmer';
import { AnwesenheitService } from '../_services/anwesenheit.service';
import { Fehlzeiten } from '../_models/fehlzeiten';
import { User } from '../_models/user';
//import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'add-absence',
  templateUrl: './add-absence.component.html'
})
export class AddAbsenceComponent implements OnInit {

  constructor(private absencesService: AnwesenheitService) { }

  ngOnInit() {

  }

  _student: Kursteilnehmer;

  IsCanceled: boolean = false;
  @Output()
  AddAbsenceCanceled: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  AddAbsenceAdded: EventEmitter<string> = new EventEmitter();

  AbsenceDate: string = this.getToday();
  AbsenceDateEnd: string = this.getToday();
  AbsenceGrund: string = "unentschuldigt";
  AbsenceTimeFrom: string = "08:15";
  AbsenceTimeTo: string = "16:30";
  AbsenceRecordToDelete: Fehlzeiten;
  _user: User;
  _isTrainer: boolean = false;

  @Input() set isTrainer(istrainer: boolean) {
    this._isTrainer = istrainer;
  }

  @Input() set timeUpdate(p: boolean) {
    let now: Date = new Date();
    if (now.getHours() < 12) {
      this.AbsenceTimeFrom = "08:15";
      this.AbsenceTimeTo = Fehlzeiten.aktuelleZeit();
    } else {
      this.AbsenceTimeTo = "16:30";
      this.AbsenceTimeFrom = Fehlzeiten.aktuelleZeit();
    }
  }

  /// <summery>asdfkjl sdlk</summery>
  getToday(): string {
    let today: Date = new Date();
    let dd: string = ("0" + (today.getDate())).slice(-2);
    let mm: string = ("0" + (today.getMonth() + 1)).slice(-2);
    let yyyy: string = today.getFullYear().toString();
    yyyy + "-" + mm + "-" + dd;
    return yyyy + "-" + mm + "-" + dd;
  }

  ConvertDateToString(today: Date) {
    let dd: string = ("0" + (today.getDate())).slice(-2);
    let mm: string = ("0" + (today.getMonth() + 1)).slice(-2);
    let yyyy: string = today.getFullYear().toString();
    yyyy + "-" + mm + "-" + dd;
    return yyyy + "-" + mm + "-" + dd;
  }

  onAddAbsenceCanceled() {
    this.AddAbsenceCanceled.emit();
  }

  onAddAbsenceAdded() {
    this.AddAbsenceAdded.emit();
  }

  Cancel() {
    this.IsCanceled = true;
    this.onAddAbsenceCanceled();
  }

  Save() {
    if (this.Timespan == false) { //Zeiten hinzufügen

      if (Date.parse("01/01/2011 " + this.AbsenceTimeFrom + ":00") < Date.parse("01/01/2011 " + this.AbsenceTimeTo + ":00")) {
        if (this.student.fehlzeiten.filter(this.filter).length > 0) {
          for (let absence of this.student.fehlzeiten.filter(this.filter)) {
            if (
              (Date.parse("01/01/2011 " + absence.von) >= Date.parse("01/01/2011 " + this.AbsenceTimeTo + ":00")) ||
              (Date.parse("01/01/2011 " + absence.bis) <= Date.parse("01/01/2011 " + this.AbsenceTimeFrom + ":00"))
            ) {
              console.log("save!!!");
              console.log("alt: " + absence.von + "   " + absence.bis);
              console.log("neu: " + this.AbsenceTimeFrom + "   " + this.AbsenceTimeTo);
              this.SaveAbsence();
            }
            else {
              alert("Die Zeiten überschneiden sich!!!");
              console.log("alt: " + absence.von + "   " + absence.bis);
              console.log("neu: " + this.AbsenceTimeFrom + "   " + this.AbsenceTimeTo);
            }
          }
        } else {
          console.log("save");
          this.SaveAbsence();
        }

      }
      else {
        alert("Die Zeitspanne ist negativ!");
      }
    }
    else { // Tage hinzufügen
      let startDate: number = Date.parse(this.AbsenceDate);
      let endDate: number = Date.parse(this.AbsenceDateEnd);
      if (startDate < endDate) {
        let days: number = (endDate - startDate) / 1000 / 60 / 60 / 24;
        days++;
        let dates: Fehlzeiten[] = new Array(days);
        let weekendDaysIndexArray: number[];
        let dateTmp: Fehlzeiten = new Fehlzeiten(this._student.kursteilnehmerNr);
        dateTmp.datum = this.ConvertDateToString(new Date(startDate));
        dateTmp.von = "08:15";
        dateTmp.bis = "16:30";
        dateTmp.entschuldigt = this.AbsenceGrund == "unentschuldigt" ? false : true;
        dateTmp.entschuldigung = this.AbsenceGrund;
        for (var i = 0; i < dates.length; i++) {
          dates[i] = dateTmp;
          startDate += 1000 * 60 * 60 * 24;
          dateTmp = new Fehlzeiten(this._student.kursteilnehmerNr);
          dateTmp.datum = this.ConvertDateToString(new Date(startDate));
          dateTmp.von = "08:15";
          dateTmp.bis = "16:30";
          dateTmp.entschuldigt = this.AbsenceGrund == "unentschuldigt" ? false : true;
          dateTmp.entschuldigung = this.AbsenceGrund;
        }
        for (var i = dates.length - 1; i >= 0; i--) {
          let day = new Date(Date.parse(dates[i].datum)).getDay();
          if (day == 0 || day == 6) {
            console.log("weekend");
            dates.splice(i, 1);
          }
        }
        console.log(dates);
        for (var i = 0; i < dates.length; i++) {
          console.log("stuedent fehlzeiten:")
          console.log(this._student.fehlzeiten);
          console.log(this._student.fehlzeiten.filter((a) => { return a.datum == dates[i].datum + "T00:00:00" }));
          if (this._student.fehlzeiten.filter((a) => { return a.datum == dates[i].datum + "T00:00:00" }).length > 0) {
            alert("Zeitüberschneidung!");
            console.log("checked!")
            return;
          }
          console.log("nach intersection pruefung");
        }
        this.SaveAbsenceDates(dates);
      } else {
        alert("Enddatum ist vor oder gleich dem Startdatum!");
      }
    }
    this.onAddAbsenceAdded();
  }

  SaveAbsence() {
    let data: Fehlzeiten = new Fehlzeiten(this._student.kursteilnehmerNr);
    data.datum = this.AbsenceDate;
    data.von = this.AbsenceTimeFrom + ":00";
    data.bis = this.AbsenceTimeTo + ":00";
    data.entschuldigt = this.AbsenceGrund == "unentschuldigt" ? false : true;
    data.entschuldigung = this.AbsenceGrund;
    console.log(this.AbsenceGrund);
    this.absencesService.postNewTnFehlzeiten(data).subscribe(x => {
      data = x;
    }, err => {
      console.log("Add Absence POST error: ");
      console.log(err);
    }, () => {
      this._student.fehlzeiten.push(data);
    });
  }

  SaveAbsenceDates(dates: Fehlzeiten[]) {
    for (var i = 0; i < dates.length; i++) {
      this.absencesService.postNewTnFehlzeiten(dates[i]).subscribe(x => {
        dates[i] = x;
        //dates[i].entschuldigung = this.AbsenceGrund;
      }, err => {
        console.log("Add Absence POST error: ");
        console.log(err);
      }, () => {
        this._student.fehlzeiten.push(dates[i]);
      });
    }
  }

  filter: IFilterAbsences = x => {
    return x.datum == this.AbsenceDate + "T00:00:00";
  };

  sort: ISortAbsences = (a, b) => {
    if (a.datum > b.datum) return 1; else return -1;
  };

  get student() {
    return this._student;
  }

  _timespan: boolean = false;

  get Timespan() {
    return this._timespan;
  }

  @Input() set Timespan(Timespan: boolean) {
    this._timespan = Timespan;
    if (this._timespan) {
      //tage
      this.filter = x => {
        if ((x.datum >= this.AbsenceDate + "T00:00:00") && (x.datum <= this.AbsenceDateEnd + "T00:00:00"))
          return true;
        else
          return false;
      }
    } else {
      //zeiten
      this.filter = x => {
        return x.datum == this.AbsenceDate + "T00:00:00";
      };
    }
  }

  @Input() set student(student: Kursteilnehmer) {
    this._student = student;
    console.log("Trainer: " + this._isTrainer);
    if (this._isTrainer) {
      //this._student.anwesend = true;
      //this.absencesService.getTnFehlzeitenHeute(this._student.kursteilnehmerNr).subscribe(
      //  fs => this._student.fehlzeiten = fs,
      //  err => console.log(err),
      //  () => {
      //    //console.log(tn.fehlzeiten);
      //    this._student.anwesend = !Kursteilnehmer.hatGanzTagFehlzeit(this._student);
      //    //if (i + 1 == a.length && j + 1 == arr.length) this.studentsLoaded = true;
      //    console.log("Nach ganztagspruefing");
      //    console.log(this._student.fehlzeiten);
      //  }
      //);
    } else {
      this.absencesService.getFehlzeitenByTn(this._student.kursteilnehmerNr)
        .subscribe(
          absencesToday => {
            this._student.fehlzeiten = absencesToday;
            console.log(absencesToday);
          },
          err => console.log(err),
          () => {
            console.log(this._student);
          }
        );
    }
  }

  DeleteAbsence(event) {
    //console.log(event);
    let id: string = event.target.id.substring(3);
    //document.getElementById('modalheader').innerText = "Datensatz löschen?";
    this.AbsenceRecordToDelete = this.student.fehlzeiten.filter(f => f.fehlzeitenId == event.target.id.substring(3))[0];
    //document.getElementById('modalbody').innerHTML =
    //  "<table class='table-sm'><tr><td>Id:</td><td class='text-right'>" + id +
    //  "</tr><tr><td>Datum:</td><td class='text-right'>" + new Date(this.AbsenceRecordToDelete.datum).toLocaleDateString() +
    //  "</tr><tr><td>von:</td><td class='text-right'>" + this.AbsenceRecordToDelete.von +
    //  "</tr><tr><td>bis:</td><td class='text-right'>" + this.AbsenceRecordToDelete.bis +
    //  "</td></tr></table>";

    let x = confirm("Wirklich löschen");
    if (x) {
      this.DeleteAck();
    }
  }

  DeleteAck() {
    this.absencesService.delete(this.AbsenceRecordToDelete).subscribe(x => { }, err => console.log(err),
      () => {
        let index = this._student.fehlzeiten.indexOf(this.AbsenceRecordToDelete);
        console.log(index);
        this._student.fehlzeiten.splice(index, 1);
        this.AbsenceRecordToDelete = null;
      })
  }

  onSelectionChanged(event) {
    console.log(event);
    let id = event.target.parentElement.id;
    let absence = this.student.fehlzeiten.find(x => x.fehlzeitenId == id);
    if (absence.entschuldigung != event.target.text) {
      absence.entschuldigung = event.target.text;
      absence.entschuldigt = absence.entschuldigung == "unentschuldigt" ? false : true;
    }
    this.absencesService.postChangeTnFehlzeiten(absence).subscribe(x => { }, err => console.log(err));
  }



}
interface IFilterAbsences {
  (ab: Fehlzeiten): boolean
}

interface ISortAbsences {
  (a: Fehlzeiten, b: Fehlzeiten): number;
}




// WEBPACK FOOTER //
// ./src/app/_components/add-absence.component.ts